// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__32nMj","modalForm":"UpgradeEpcsModal_modalForm__3Gct3","modalFooter":"UpgradeEpcsModal_modalFooter__33UYU"};